import React from 'react'
import R from 'ramda'
import {FormattedMessage, injectIntl, defineMessages} from 'react-intl'
import Autocomplete from 'react-autocomplete'

import Icon from './Icon'

const messages = defineMessages({
  addAPointMessage: {
    id: 'Add a point of interest',
    defaultMessage: 'Add a point of interest',
  }
})

const PoiEntry = ({address, poiOptions, searchingPoi, onSearch, onAdd, intl}) => {
  const icon = searchingPoi ? <Icon name="cog fa-spin"/> : <Icon name="search"/>
  return <div className="poi-entry">
      <div className="poi-entry-description">
        <div className="right-inner-addon">
          <Autocomplete
            inputProps={{className: "form-control", placeholder: intl.formatMessage(messages.addAPointMessage)}}
            inputStyle={{width: "100%"}}
            wrapperStyle={{width: "100%"}}
            value={address}
            items={poiOptions}
            type="search"
            getItemValue={(item) => item.fullAddressSuggestion}
            renderMenu={(items, value, style) => {
              if(value && R.isEmpty(poiOptions) && !searchingPoi) {
                return <ul className="dropdown-menu dropdown-menu-visible" style={{...style}} >
                  <li className="disabled">
                    <FormattedMessage id="We don't know this point" defaultMessage="We don't know this point" tagName="a"/>
                  </li>
                </ul>
              }
              if(value && !searchingPoi) {
                return <ul className="dropdown-menu dropdown-menu-visible" style={{...style, right: "26px", minWidth: "initial", left: "initial"}} children={items}/>
              }
              if(searchingPoi) {
                return <ul className="dropdown-menu dropdown-menu-visible" style={{...style}}>
                  <li className="disabled">
                    <FormattedMessage id="Searching you point of interest" defaultMessage="Searching you point of interest" tagName="a"/>
                  </li>
                </ul>
              }
              return <span/>
              }
            }
            renderItem={(poi) => {return <li> <a>{poi.fullAddressSuggestion}</a></li>}}
            onSelect={(event, value) => onAdd(value)}
            onChange={(event, value) => onSearch(value)}
            />
          {icon}
        </div>
      </div>
    </div>
}

PoiEntry.propTypes = {
  address: React.PropTypes.string.isRequired,
  poiOptions: React.PropTypes.array.isRequired,
  searchingPoi: React.PropTypes.bool.isRequired,
  onSearch: React.PropTypes.func.isRequired,
  onAdd: React.PropTypes.func.isRequired,
}

export default injectIntl(PoiEntry)



/** WEBPACK FOOTER **
 ** ./app/components/PoiEntry.jsx
 **/